<ng-container *ngIf="message?.errorMsgId">
  <div class="c-form-element-error" role="alert" aria-live="polite">
    <p id="{{ id }}" class="c-form-element-error__message">
      <em
        class="c-form-element-error__message-text"
        [innerHTML]="
          msgKeyPrefix + message?.errorMsgId!
            | paramsTranslate : message?.params || []
            | popupIndicator
            | metaUrl
            | linkStyle
        "
      ></em>
    </p>
  </div>
</ng-container>
